export namespace Message {
  /**
   * システムメッセージ
   */
  export namespace INFO_MASSAGE {
    export const INF001 = '注文を削除しますが、よろしいですか？';
    export const INF002 = '注文を確定しますがよろしいですか？';
    export const INF003 = 'ご注文を承りました。\n注文番号:{0}';
    export const INF004 = '該当データが存在しません。';
    export const INF005 = '{0}がマスタに登録されていません。';
    export const INF006 = '{0}を更新しました。';
    export const INF007 = '{0}を削除しました。';
    export const INF008 = '{0}を登録しました。';
    export const INF009 = '編集データがないため更新されませんでした。';
    export const INF010 =
      '最大表示件数（1000件）以上のデータを取得しました。\n検索条件を指定して再検索してください。';
    export const INF011 =
      '他で更新された為更新できませんでした。\n再度照会画面から注文を選択してください。';
    export const INF012 = '他で更新された為更新できませんでした。\n再度検索を行ってください。';
  }
  /**
   * エラーメッセージ
   */
  export namespace ERROR_MASSAGE {
    export const ERR001 = '{0}は必須項目です。';
    export const ERR999 = '{0}でシステムエラーが発生しました。';
    export const ERR002 =
      'アカウントIDがロックされています。\nパスワードリセットを行うか当社へお問い合わせください。';
    export const ERR003 = 'パスワードを設定してください。';
    export const ERR004 = '有効期限切れです。パスワードを変更してください。';
    export const ERR005 = 'パスワードが違います。';
    export const ERR006 = '見本板管理No指定する場合は、対応する現物管理No入力してください。';
    export const ERR007 = 'パスワードは、大文字小文字英数字混在の12文字以上で設定いただけます。';
    export const ERR008 = '入力されたパスワードは過去に使用されているため使用できません。';
    export const ERR009 = '入力されたメールアドレスと、登録済み情報が一致しません。';
    export const ERR010 = '該当する製品がありません。';
    export const ERR011 = '該当する工事管理番号がありません。';
    export const ERR012 = '更新対象の受注データが存在しません。';
    export const ERR013 = '更新対象の受注データは削除済のため更新できません。';
    export const ERR014 = 'カンパニーCDまたはアカウントIDが存在しません。';
    export const ERR015 = '確認用パスワードが変更パスワードと違います。';
    export const ERR016 = '明細が１件も入力されていません。';
    export const ERR017 = '{0}は半角英数字のみ入力可能です。';
    export const ERR018 = '{0}は半角数字のみ入力可能です。';
    export const ERR019 = '{0}は半角数字と「-」のみ入力可能です。';
    export const ERR020 = '{0}は半角英数字と記号のみ入力可能です。';
  }
}
